(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["st-cert-course"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('cert-course-form')){customElements.define('cert-course-form',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.addEventListener('change',event=>{if(event.target.name==='id'){this.querySelector('[data-enroll-price]').textContent=event.target.dataset.price;}});}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-cert-educators"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cert-educator-directory')) customElements.define('cert-educator-directory', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return; this.ready = true;
    const search = this.querySelector('[data-people-search]'), state = this.querySelector('[data-people-state]');
    const cards = [...this.querySelectorAll('[data-person]')];
    const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
    const update = () => {
      const query = normalize(search.value.trim()); let count = 0;
      cards.forEach(card => { card.hidden = (!!state.value && state.value !== card.dataset.state) || !normalize(card.dataset.search).includes(query); if (!card.hidden) count++; });
      this.querySelector('[data-people-count]').textContent = `${count} ${count === 1 ? this.dataset.singular : this.dataset.plural}`;
      this.querySelector('[data-people-empty]').hidden = count > 0;
    };
    search.addEventListener('input', update); state.addEventListener('change', update);
    this.querySelector('[data-people-reset]').addEventListener('click', () => { search.value = ''; state.value = ''; update(); search.focus(); });
    const initial = new URLSearchParams(location.search).get('educator'); if (initial) search.value = initial;
    update();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-cert-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cert-state-directory')) {
  customElements.define('cert-state-directory', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const search = this.querySelector('[data-directory-search]');
      const groups = [...this.querySelectorAll('[data-state]')];
      const cards = [...this.querySelectorAll('[data-location]')];
      const stateSelect = this.querySelector('[data-mobile-state-select]');
      groups.forEach(group => {
        const option = document.createElement('option');
        option.value = group.dataset.state;
        option.textContent = group.querySelector('summary h2').textContent;
        stateSelect.append(option);
      });
      this.querySelector('[data-mobile-state-jump]').hidden = false;
      const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
      const initialOpen = new Set(groups.filter(group => group.open));
      let searching = false;
      const update = () => {
        const query = normalize(search.value.trim());
        stateSelect.value = '';
        if (query && !searching) { initialOpen.clear(); groups.filter(group => group.open).forEach(group => initialOpen.add(group)); }
        let count = 0;
        cards.forEach(card => { card.hidden = !!query && !normalize(card.dataset.search).includes(query); if (!card.hidden) count++; });
        groups.forEach(group => {
          group.hidden = ![...group.querySelectorAll('[data-location]')].some(card => !card.hidden);
          if (query) group.open = !group.hidden;
          else if (searching) group.open = initialOpen.has(group);
        });
        this.querySelector('[data-directory-count]').textContent = query ? count + ' ' + (count === 1 ? this.dataset.matchSingular : this.dataset.matchPlural) : '';
        this.querySelector('[data-directory-empty]').hidden = count > 0;
        searching = !!query;
      };
      stateSelect.addEventListener('change', () => {
        if (!window.matchMedia('(max-width:749px)').matches) return;
        const group = groups.find(item => item.dataset.state === stateSelect.value);
        if (!group) return;
        search.value = ''; update();
        groups.forEach(item => { item.open = item === group; });
        stateSelect.value = group.dataset.state;
        group.querySelector('summary').focus({preventScroll:true});
        group.scrollIntoView({block:'start',behavior:'auto'});
      });
      search.addEventListener('input', update);
      this.querySelector('[data-directory-reset]').addEventListener('click', () => { search.value = ''; update(); search.focus(); });
      const educator = new URLSearchParams(window.location.search).get('educator');
      if (educator) { search.value = educator; update(); }
      const openHash = () => {
        const hash = window.location.hash.slice(1).toLocaleLowerCase();
        const group = groups.find(item => item.dataset.state === hash || item.id === hash);
        if (group) { search.value = ''; update(); group.open = true; group.scrollIntoView({block: 'start'}); }
      };
      window.addEventListener('hashchange', openHash);
      openHash();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-cert-header"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.sc-mobile-menu').forEach(menu => {
  if (menu.dataset.mobileReady) return;
  menu.dataset.mobileReady = 'true';
  const mobile = window.matchMedia('(max-width:749px)');
  const close = () => { if (mobile.matches) menu.open = false; };
  menu.addEventListener('keydown', event => {
    if (mobile.matches && event.key === 'Escape' && menu.open) {
      menu.open = false; menu.querySelector('summary').focus();
    }
  });
  menu.querySelectorAll('nav a').forEach(link => link.addEventListener('click', close));
  document.addEventListener('click', event => {
    if (mobile.matches && menu.open && !menu.contains(event.target)) close();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-cert-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cert-review-proof')) {
  customElements.define('cert-review-proof', class extends HTMLElement {
    connectedCallback() {
      this.sync = () => {
        const source = document.querySelector('.jdgm-carousel-wrapper');
        const rating = Number(source?.querySelector('.jdgm-all-reviews-rating')?.dataset.score);
        const count = Number(source?.querySelector('.jdgm-carousel-number-of-reviews')?.dataset.numberOfReviews);
        if (!Number.isFinite(rating) || rating <= 0 || rating > 5 || !Number.isInteger(count) || count < 1) return false;
        this.querySelector('[data-review-score]').textContent = this.dataset.scoreLabel.replace('__score__', rating.toFixed(2));
        this.querySelector('[data-review-count]').textContent = this.dataset.countLabel.replace('__count__', count.toLocaleString(document.documentElement.lang || 'en'));
        this.querySelector('[data-review-score]').hidden = false;
        this.querySelector('svg').removeAttribute('hidden');
        const reviewsSection = source.closest('.shopify-section');
        if (reviewsSection?.id) this.querySelector('a').href = '#' + reviewsSection.id;
        return true;
      };
      if (this.sync()) return;
      this.observer = new MutationObserver(() => {
        if (this.sync()) {
          this.observer.disconnect();
          clearTimeout(this.timeout);
        }
      });
      this.observer.observe(document.getElementById('main') || document.body, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['data-score', 'data-number-of-reviews']
      });
      this.timeout = setTimeout(() => this.observer.disconnect(), 15000);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      clearTimeout(this.timeout);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-cert-online-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cert-course-gallery')) customElements.define('cert-course-gallery', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return; this.ready = true;
    const main = this.querySelector('.sc-course-main-photo img');
    const thumbs = [...this.querySelectorAll('[data-gallery-thumb]')];
    thumbs.forEach(button => button.addEventListener('click', () => {
      const source = button.querySelector('img'); main.srcset = source.srcset; main.src = source.src; main.alt = source.alt;
      thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === button)));
    }));
  }
});
if (!customElements.get('cert-online-form')) customElements.define('cert-online-form', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return; this.ready = true;
    const native = this.querySelector('[data-native-variant]');
    const options = [...this.querySelectorAll('[data-course-option]')];
    const variants = [...native.options];
    const sync = () => {
      const variant = variants.find(item => options.every((select, index) => item.getAttribute(`data-option-${index}`) === select.value));
      const available = !!variant && variant.dataset.available === 'true';
      native.value = variant ? variant.value : '';
      if (variant) this.querySelector('[data-course-price]').textContent = variant.dataset.price;
      this.querySelector('[data-online-enroll]').disabled = !available;
      this.querySelector('[data-variant-status]').hidden = available;
    };
    const selected = native.selectedOptions[0];
    if (selected) options.forEach((select, index) => { select.value = selected.getAttribute(`data-option-${index}`); });
    options.forEach(select => select.addEventListener('change', sync));
    this.querySelector('[data-enhanced-options]').hidden = false;
    this.querySelector('[data-variant-fallback]').hidden = true;
    this.querySelector('form').addEventListener('submit', event => { if (this.querySelector('[data-online-enroll]').disabled) event.preventDefault(); });
    sync();
  }
});


  } catch(e) { console.error(e); }
})();
})();
